import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'neutral' | 'ghost' | 'cream';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  isLoading?: boolean;
  children: React.ReactNode;
}

const variantStyles: Record<ButtonVariant, string> = {
  primary: 'bg-[#404040] hover:bg-[#333333] text-white border border-[#404040] shadow-sm',
  secondary: 'bg-secondary-500 hover:bg-secondary-600 text-white border border-secondary-500 shadow-sm',
  danger: 'bg-error-500 hover:bg-error-600 text-white border border-error-500 shadow-sm',
  neutral: 'bg-neutral-800 hover:bg-neutral-900 text-white border border-neutral-800 shadow-sm',
  ghost: 'bg-transparent hover:bg-neutral-100 text-neutral-900 border border-neutral-300',
  cream: 'bg-[#E3DED9] hover:bg-[#d9d2cb] text-[#101828] border border-[#D0D5DD] shadow-sm',
};

const sizeStyles: Record<ButtonSize, string> = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2.5 text-base',
  lg: 'px-6 py-3 text-lg',
};

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled = false,
  children,
  className = '',
  ...props
}) => {
  return (
    <button
      disabled={isLoading || disabled}
      className={`inline-flex items-center justify-center gap-2 font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${variantStyles[variant]} ${sizeStyles[size]} ${className}`}
      {...props}
    >
      {isLoading && (
        <div className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
      )}
      {children}
    </button>
  );
};

export default Button;
